import { CLOUDTRUCKS_SUCCESS_MOBILE } from 'helpers/constants'

export const MAX_ATTEMPTS: number = 5
export const CONTACT_ERROR = `You will receive a code from us if you are in our system. Please contact Cloud Trucks customer service for more information at ${CLOUDTRUCKS_SUCCESS_MOBILE}.`
export const BAD_CODE_ERROR = `Please check the verification code and try again. Contact Cloud Trucks customer service for more information at ${CLOUDTRUCKS_SUCCESS_MOBILE}.`
